// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_lv-0";